<template>
    <div>
        <Header :label="$t('emailverification.headerLabel')" overlap="small" />
        <MainLayout>
            <Paper tall slot="center">
                <div v-if="shouldBeShowingLoadState" class="spinner-container">
                    <h5 :class="['loading-text', dotClass]">
                        {{ $t('emailverification.verifyingEmail') }}
                    </h5>
                    <Spinner />
                </div>
                <template v-else>
                    <div
                        v-if="!error"
                        class="m-5 mb-7 d-flex flex-column align-items-center"
                    >
                        <h4>
                            {{ $t('emailverification.emailVerifySuccess') }}
                        </h4>
                        <BaseIcon
                            name="check"
                            class="mt-4"
                            style="color: green; font-size: 60px"
                        />
                        <BaseButton @click="gotoMyPage" class="mt-4 outlined">{{
                            $t('emailverification.gotoMyPage')
                        }}</BaseButton>
                    </div>
                    <div
                        v-else
                        class="m-5 mb-7 d-flex flex-column align-items-center"
                    >
                        <h4>
                            {{ $t('emailverification.emailVerifyFailure') }}
                        </h4>
                        <BaseIcon
                            name="sad-tear"
                            class="mt-4"
                            style="color: var(--error); font-size: 60px"
                        />
                        <BaseButton @click="gotoMyPage" class="mt-4 outlined">{{
                            $t('emailverification.gotoMyPage')
                        }}</BaseButton>
                    </div>
                </template>
            </Paper>
        </MainLayout>
    </div>
</template>

<script>
// Project Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import Spinner from '~/components/builders/Spinner';

export default {
    name: 'EmailVerification',
    components: { Header, MainLayout, Spinner },
    data() {
        return {
            emailToken: this.$route.query.emailToken || '', // Used for user creation
            userId: this.$route.query.userId || '', // Used for both user creation and school connection
            token: this.$route.query.token || '', // Used for both school connection
            c: this.$route.query.c || '', // Used for both school connection
            loading: true,
            error: null,
            dotInterval: null,
            dotClass: '',
            dotCounter: 0,
            minLoadingTime: 1, //(sec as uint) This is used to artifically lengthen the loading time, so that the user feels something happened (our api is so fast the result is in before the page has loaded, this ensures the user sees a loading screen)
        };
    },
    computed: {
        shouldBeShowingLoadState() {
            // This is used to combine the loading state and the minLoadingTime to ultimately determine if loading spinner should be shown
            return this.loading || this.dotCounter < this.minLoadingTime * 2;
        },
    },
    methods: {
        incrementDots() {
            this.dotCounter = this.dotCounter + 1;
            switch (this.dotClass) {
                case '':
                    this.dotClass = 'after1';
                    break;
                case 'after1':
                    this.dotClass = 'after2';
                    break;
                case 'after2':
                    this.dotClass = 'after3';
                    break;
                case 'after3':
                    this.dotClass = '';
                    break;
            }
        },
        verifyEmail() {
            // gets called in mounted()
            if (this.emailToken && this.userId) {
                this.$interfaces.user.email.verify
                    .get({
                        emailToken: this.emailToken,
                        userId: this.userId,
                    })
                    .then(res => {
                        if (res.error) {
                            // If this happens something went wrong with the api
                            this.error = res.error;
                        }
                        console.log(res);
                    })
                    .catch(err => {
                        // If this happens something went wrong with RestX
                        this.error = err;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else if (this.userId && this.token && this.c) {
                this.$interfaces.university.connection.verify
                    .get({
                        userId: this.userId,
                        token: this.token,
                        c: this.c,
                    })
                    .then(res => {
                        if (res.error) {
                            // If this happens something went wrong with the api
                            this.error = res.error;
                        } else {
                            this.$interfaces.university.connection.get({
                                forceUpdate: true,
                            });
                        }
                        console.log(res);
                    })
                    .catch(err => {
                        // If this happens something went wrong with RestX
                        this.error = err;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                //this.$router.push(this.$URLS.findjobs);
            }
        },
        gotoMyPage() {
            this.$router.push(this.$URLS.mypage);
        },
    },
    watch: {
        shouldBeShowingLoadState(isLoading, wasLoading) {
            if (isLoading !== wasLoading) {
                if (isLoading) {
                    this.dotInterval = setInterval(this.incrementDots, 500);
                } else {
                    clearInterval(this.dotInterval);
                    this.dotInterval = null;
                }
            }
        },
    },
    mounted() {
        console.log(this.$route, this.emailToken);
        this.dotInterval = setInterval(this.incrementDots, 500);
        this.$interfaces.logInModule.setDisabledPopup();
        this.verifyEmail();
    },
    beforeDestroy() {
        clearInterval(this.dotInterval);
    },
};
</script>

<style scoped>
.spinner-container {
    min-height: 200px;
    height: 200px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--primary);
}

.after1::after {
    position: absolute;
    content: '.';
}
.after2::after {
    position: absolute;
    content: '..';
}
.after3::after {
    position: absolute;
    content: '...';
}

.outlined {
    border: 1px solid black;
}
</style>
